// extracted by mini-css-extract-plugin
export default {"rating":"lH-z","numberOfStars":"mH-z","count":"nH-z","barGraphSpacing":"oH-z","barGraph":"pH-z"};